$(function() {

    // Collect variables that will be needed below
    var filters = $('.advanced-filter'), // all of the <li>s in the sidebar
        searchUrl = '/search?q=', // Useful for recreating the search URL if needed
        baseUrl = window.location.protocol + "//" + window.location.host, // URL of page before /search params are added
        currentUrl = $(location).attr('href'), // URL of the page with all the current search terms.
        urlParamArray = [], // This will hold an array with 2 items, the url and the search terms
        urlParams = [], // This will hold multiple search terms
        activeHandle = ''; // This will hold the handle of the clicked element

    // Create variables for all the <li>s
    filters.each(function() {
        var el = $(this),
            handle = el.data('handle'),
            isActive = el.hasClass('active-filter');
    });

    // Actions to perform when <li> is clicked
    filters.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var el = $(this),
            handle = el.data('handle').toString(); // Turn data-handle into a string. Needed for Approximate Width which is listed as an Int
//             if (currentUrl.search("/search?q=") >= 0)
            if ( document.location.href.indexOf('/search?q=') > -1 ){
//               alert("found it");
            } else {
              currentUrl = searchUrl
            }
        // Continue as normal if we're clicking on the active link
        if ( el.hasClass('active-filter') ) {
            activeHandle = handle;
            urlParamArray = currentUrl.split('q='); // Create array of current URL, spliting into two arrays, second array holds the search terms

            // Using a regular expression to test the second array (with search terms)
            // Looking for only (alphanumeric, -, and _ ).
            // If there isn't a + sign, then urlParamArray[1] only has 1 search term in it
            // If there are characters that fail the if, then there are more than 1 search term and
            // a new array is created, split at the '+'
            if (/^[0-9A-Za-z\-_]+$/.test(urlParamArray[1])) {
                urlParams = urlParamArray[1];
            } else {
                urlParams = urlParamArray[1].split('+');
            } // end check to search terms in url

            // If the url exists and the second array only has 1 search term
            // Check if the current handle and the search term match, if so, remove from url
            if( urlParamArray.length > 0 && (/^[0-9A-Za-z\-_]+$/.test(urlParamArray[1]) ) ) {

                if( urlParams == handle ) {
                    // if handle == the urlParams then the item clicked is to be removed from the url
                    var removeHandle = currentUrl.replace(activeHandle, '');
                } else {
                    // fallback. sets the remove handle as the current handle and kicks out of the click statment
                    var removeHandle = currentUrl;
                    return;
                }
            // If the url exists and has multiple search terms in urlParams
            } else if( urlParamArray.length > 0 ) {

                // loop through the search terms in urlParams to check against the activeHandle
                // this is done to prevent 'deep-green' from being able to effect 'medium-deep-green'
                for( var i in urlParams ) {
                    // check if current search term == the activeHandle
                    if( urlParams[i] == activeHandle ) {
                        // if yes, check if current search term is the first in the urlParams array
                        // this is to replace the term and the '+' behind it.
                        // else, remove term and the '+' in front of it
                        // break out of for loop
                        if( urlParams[0] == handle ) {
                            //var removeHandle = currentUrl.replace((activeHandle + '+OR+'), '');
                          	var removeHandle = currentUrl.replace((activeHandle + '+'), '');
                            break;
                        } else {
                            //var removeHandle = currentUrl.replace(('+OR+' + activeHandle), '');
                          var removeHandle = currentUrl.replace(('+' + activeHandle), '');
                            break;
                        }
                    // If the current search term doesn't == the active handle, then set removeHandle
                    // to the currentUrl. This prevents terms that are similar from causing problems
                    } else {
                        var removeHandle = currentUrl;
                    }
                } // end for loop of urlParams
            // fallback remove the activeHandle from the url
            } else {

                var removeHandle = currentUrl.replace(activeHandle, '');
            }
            // replace the window url with the changed url in removeHandle and leave the click function
            location.replace(removeHandle);
            return;
        } // end if(el.hasClass('active-filter'))

        // If the <li> doesn't have the class of 'active-filter'
        // check if the handle has '_' in it, if so check if the searchHandle[0] is 'ssp' or 'scg'
        // these are tags that need to be searched buy their full handle, which we don't have to have to show in the sidebar
        // If handle is for 'ssp' or 'scg', then rebuild the searchHandle to include the front
        var searchHandle = handle.split('_');
        if( searchHandle[0] == 'ssp' || searchHandle[0] == 'scg' || searchHandle[0] == 'clg' || searchHandle[0] == 'year' ) {
            searchHandle = searchHandle[0] + '_' + searchHandle[1];
        }
        // split current url second element will contain the current search terms
        var urlNums = currentUrl.split('q=');
        // check if there are search terms, if no, add the searchHandle to the currentUrl
        if( urlNums[1] == "" ) {
            currentUrl = currentUrl + searchHandle;
        // if search terms already exist, then add a '+' to the url before the searchHandle addition
        } else {
            //currentUrl = currentUrl + '+OR+' + searchHandle;
          currentUrl = currentUrl + '+' + searchHandle;
        }

        location.replace(currentUrl);

    }); // end filters.on('click')
}); // end function()




